import _ from 'lodash'

class SubscriptionModalCtrl {
    /** @ngInject */
    constructor($state, gaEventsService) {
        this.$state = $state
        this.gaEventsService = gaEventsService
    }

    $onInit() {
        this.redirectTo = null
        this.gaEventsService.newEvent('open modal - Modal Souscription ChangementFournisseur/Emmenagement')
    }

    redirect(redirectTo) {
        if (redirectTo === 'subscriptionChangementFournisseur') {
            this.gaEventsService.newEvent('click - Je change de fournisseur dans mon logement actuel')
        } else if (redirectTo === 'subscriptionEmmenagement') {
            this.gaEventsService.newEvent('click - J’emménage dans un nouveau logement')
        }
        this.$state.go(redirectTo, this.stateParams || {})
        this.close()
    }
}

export default {
    template: require('./subscriptionModal.jade')(),
    controller: SubscriptionModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&', // {$value: myRejectedResult}
    },
}



// WEBPACK FOOTER //
// ./src/states/modal/subscriptionModal.js